import posthog from 'posthog-js';

class AnalyticsService {
  private initialized = false;

  init() {
    const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
    const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

    if (!apiKey) {
      console.warn('PostHog API key not found, analytics disabled');
      return;
    }

    try {
      posthog.init(apiKey, {
        api_host: host || 'https://us.i.posthog.com',
        // Enable session replay
        session_recording: {
          maskAllInputs: false,
          maskTextSelector: '[data-private]', // Mask elements with data-private attribute
        },
        // Autocapture clicks, page views
        autocapture: {
          dom_event_allowlist: ['click'], // Only autocapture clicks
          url_allowlist: ['aetherstudio.ai', 'localhost'], // Only on our domains
        },
        // Performance
        capture_pageview: true,
        capture_pageleave: true,
      });

      this.initialized = true;
      console.log('PostHog analytics initialized');
    } catch (error) {
      console.error('Failed to initialize PostHog:', error);
    }
  }

  identify(userId: string, properties?: Record<string, any>) {
    if (!this.initialized) return;
    try {
      posthog.identify(userId, properties);
    } catch (error) {
      console.error('Failed to identify user:', error);
    }
  }

  track(event: string, properties?: Record<string, any>) {
    if (!this.initialized) return;
    try {
      posthog.capture(event, properties);
    } catch (error) {
      console.error('Failed to track event:', error);
    }
  }

  reset() {
    if (!this.initialized) return;
    try {
      posthog.reset();
    } catch (error) {
      console.error('Failed to reset PostHog:', error);
    }
  }
}

export const analytics = new AnalyticsService();
